export default __webpack_public_path__ + "static/media/oscer-pres-rash.65835fb7.svg";